export const YLDRProtocolDataProviderAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        type: 'address',
        name: 'addressesProvider',
        internalType: 'contract ILendingPoolAddressesProvider',
      },
    ],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [
      {
        type: 'address',
        name: '',
        internalType: 'contract ILendingPoolAddressesProvider',
      },
    ],
    name: 'ADDRESSES_PROVIDER',
    inputs: [],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [
      {
        type: 'tuple[]',
        name: '',
        internalType: 'struct AaveProtocolDataProvider.TokenData[]',
        components: [
          {
            type: 'string',
          },
          {
            type: 'address',
          },
        ],
      },
    ],
    name: 'getAllATokens',
    inputs: [],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [
      {
        type: 'tuple[]',
        name: '',
        internalType: 'struct AaveProtocolDataProvider.TokenData[]',
        components: [
          {
            type: 'string',
          },
          {
            type: 'address',
          },
        ],
      },
    ],
    name: 'getAllReservesTokens',
    inputs: [],
  },
  {
    inputs: [{ internalType: 'address', name: 'asset', type: 'address' }],
    name: 'getReserveConfigurationData',
    outputs: [
      { internalType: 'uint256', name: 'decimals', type: 'uint256' },
      { internalType: 'uint256', name: 'ltv', type: 'uint256' },
      {
        internalType: 'uint256',
        name: 'liquidationThreshold',
        type: 'uint256',
      },
      { internalType: 'uint256', name: 'liquidationBonus', type: 'uint256' },
      { internalType: 'uint256', name: 'reserveFactor', type: 'uint256' },
      { internalType: 'bool', name: 'usageAsCollateralEnabled', type: 'bool' },
      { internalType: 'bool', name: 'borrowingEnabled', type: 'bool' },
      { internalType: 'bool', name: 'isActive', type: 'bool' },
      { internalType: 'bool', name: 'isFrozen', type: 'bool' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'asset',
        type: 'address',
      },
    ],
    name: 'getReserveData',
    outputs: [
      {
        internalType: 'uint256',
        name: 'accruedToTreasuryScaled',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'totalYToken',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'totalVariableDebt',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'liquidityRate',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'variableBorrowRate',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'liquidityIndex',
        type: 'uint256',
      },
      { internalType: 'uint256', name: 'variableBorrowIndex', type: 'uint256' },
      { internalType: 'uint40', name: 'lastUpdateTimestamp', type: 'uint40' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [
      {
        type: 'address',
        name: 'aTokenAddress',
        internalType: 'address',
      },
      {
        type: 'address',
        name: 'stableDebtTokenAddress',
        internalType: 'address',
      },
      {
        type: 'address',
        name: 'variableDebtTokenAddress',
        internalType: 'address',
      },
    ],
    name: 'getReserveTokensAddresses',
    inputs: [
      {
        type: 'address',
        name: 'asset',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [
      {
        type: 'uint256',
        name: 'currentATokenBalance',
        internalType: 'uint256',
      },
      {
        type: 'uint256',
        name: 'currentStableDebt',
        internalType: 'uint256',
      },
      {
        type: 'uint256',
        name: 'currentVariableDebt',
        internalType: 'uint256',
      },
      {
        type: 'uint256',
        name: 'principalStableDebt',
        internalType: 'uint256',
      },
      {
        type: 'uint256',
        name: 'scaledVariableDebt',
        internalType: 'uint256',
      },
      {
        type: 'uint256',
        name: 'stableBorrowRate',
        internalType: 'uint256',
      },
      {
        type: 'uint256',
        name: 'liquidityRate',
        internalType: 'uint256',
      },
      {
        type: 'uint40',
        name: 'stableRateLastUpdated',
        internalType: 'uint40',
      },
      {
        type: 'bool',
        name: 'usageAsCollateralEnabled',
        internalType: 'bool',
      },
    ],
    name: 'getUserReserveData',
    inputs: [
      {
        type: 'address',
        name: 'asset',
        internalType: 'address',
      },
      {
        type: 'address',
        name: 'user',
        internalType: 'address',
      },
    ],
  },
] as const
